import CustomVideoPlayer from '../../CustomVideoPlayer'

export default {CustomVideoPlayer}
